<template>
  <v-dialog v-model="showDialog" scrollable :max-width="400">
      <v-card>
        <my-toolbar :height="55" title="Update Invoice Header"></my-toolbar>
        <v-card-text class="mt-2">
            <v-text-field v-model="itemHeader.brandName" label="Brandname"></v-text-field>
            <v-text-field v-model="itemHeader.invoiceNumber" label="Invoice Number"></v-text-field>
            <v-text-field v-model="itemHeader.invoiceDate" label="Invoice Date"></v-text-field>
            <v-text-field v-model="itemHeader.poNumber" label="PO Number"></v-text-field>
            <v-text-field v-model="itemHeader.poDate" label="PO Date"></v-text-field>
            <v-text-field v-model="itemHeader.carrierName" label="Carrier Name"></v-text-field>
            <v-text-field v-model="itemHeader.shipDate" label="Ship Date"></v-text-field>
            <v-text-field v-model="itemHeader.dueDate" label="Due Date"></v-text-field>
            <v-text-field v-model="itemHeader.terms" label="Terms"></v-text-field>
            <v-text-field v-model="itemHeader.freightCharge" label="Freight Charge"></v-text-field>
            <v-text-field v-model="itemHeader.invoiceDiscount" label="Invoice Discount"></v-text-field>
            <v-text-field v-model="itemHeader.totalCost" label="Total Cost"></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mr-3 my-2">
            <v-spacer></v-spacer>
            <v-btn depressed outlined color="primary" @click="showDialog = false">Cancel</v-btn>
            <v-btn depressed color="primary" @click="handleUpdate">Update</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import { state, getters } from '@/store/store'; 
export default {
    props: {
        visibleEditHeaderModal: {
            type: Boolean,
            required: true
        },
    },
    computed:{
        ...getters,//getParseResults
        itemHeader(){
            if(this.getParseResults.invoiceInformation){
                return this.getParseResults.invoiceInformation
            }else{
                return {}
            }
        },
        showDialog: {
            get() {
                return this.visibleEditHeaderModal;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            }
        },
    },
    methods: {
        handleUpdate(){
            state.parsedResults = {...state.parsedResults, invoiceInformation: this.itemHeader}
            this.showDialog = false
        }
    },
}
</script>